// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';

interface PostUserRequest {
  email: string;
  password: string;
  name: string;
}

interface PostUserResponse {
  id: string;
  email: string;
}

export const useRegisterUser = () => {
  const postUser = (_data: PostUserRequest): Promise<PostUserResponse> => rejectServiceClosed();

  return { postUser };
};
